<template>
    <div class="type-wysiwyg">
        <div v-if="!innerIsReview">
            <v-fade-transition mode="out-in">
                <validation-provider
                    v-slot="{ errors }"
                    :name="label || 'This'"
                    :rules="rules"
                    v-bind="providerProps"
                    v-show="innerShouldShow"
                    :vid="'validate-' + fieldAssignmentId"
                    :ref="'validate' + fieldAssignmentId"
                >
                    <div
                        v-if="innerLabel"
                        v-html="innerLabel"
                    ></div>
                    <span
                        class="field-directions"
                        v-if="directions"
                        v-html="directions"
                    ></span>

                    <element-tiptap
                            v-if="!loading"
                            id="wysiwyg"
                            height="400"
                            v-model="content"
                            v-bind="[vProps, $attrs]"
                            :extensions="extensions"
                            :placeholder="placeholder"
                            :menu-bubble-options="{ 'keep-in-bounds': false }"
                            lang="en"
                    ></element-tiptap>
<!--                    For validation     -->
                    <v-text-field v-model="content" class="hidden"></v-text-field>
                </validation-provider>
            </v-fade-transition>
        </div>
        <div v-else>
            <type-review
                v-if="extraProps"
                :label="label"
                :directions="directions"
                :should-show="innerShouldShow"
                :show-edit-button="extraProps.editButton"
                :page-number="extraProps.originalPageNumber"
                @goToPage="goToPage($event)"
            >
                <div v-if="innerValue">
                    <span v-html="innerValue"></span>
                </div>
                <div v-else>N/A</div>
            </type-review>
        </div>
    </div>
</template>

<script>
import formMixin from '../formMixin';
import TypeReview from './TypeReview';
import {
    ElementTiptap,
    Doc,
    Text,
    Paragraph,
    Heading,
    Bold,
    Underline,
    Italic,
    Strike,
    Code,
    Link,
    Image,
    Blockquote,
    ListItem,
    BulletList,
    OrderedList,
    TodoItem,
    TodoList,
    TextAlign,
    TextColor,
    Indent,
    HardBreak,
    HorizontalRule,
    CodeView,
    Fullscreen,
    History,
} from "element-tiptap";
import codemirror from "codemirror";
import "codemirror/mode/xml/xml.js"; // language
import "codemirror/addon/selection/active-line.js"; // require active-line.js
import "codemirror/addon/edit/closetag.js"; // autoCloseTags

export default {
    name: 'TypeWYSIWYG',
    mixins: [formMixin],
    inheritAttrs: false,
    components: {
        TypeReview,
        ElementTiptap
    },
    methods:{
        checkExtensions() {
            this.loading = true;
            (this.settings.allowed_extensions || []).forEach((ext) => {
                let settings = null;
                if( ext === 'Bold' || ext === 'Underline' || ext === 'Italic' || ext === 'Strike' || ext === 'Link' || ext === 'TextAlign' )
                    settings = {bubble:true};
                if( ext === 'CodeView')
                    settings = {
                            codemirror,
                            codemirrorOptions: {
                                styleActiveLine: true,
                                autoCloseTags: true,
                            },
                        };

                // let e = null;
                // if( settings )
                //     eval("e = new "+ext+"("+JSON.stringify(settings)+");");
                // else
                //     eval("e = new "+ext+"();");
                //
                // this.extensions.push(e);


                switch(ext) {
                    case 'Headings':
                        this.extensions.push(new Heading({ level: 5 }));
                        break;
                    case 'Bold':
                        this.extensions.push(new Bold(settings));
                        break;
                    case 'Underline':
                        this.extensions.push(new Underline(settings));
                        break;
                    case 'Italic':
                        this.extensions.push(new Italic(settings));
                        break;
                    case 'Strike':
                        this.extensions.push(new Strike(settings));
                        break;
                    case 'Code':
                        this.extensions.push(new Code());
                        break;
                    case 'Link':
                        this.extensions.push(new Link(settings));
                        break;
                    case 'Image':
                        this.extensions.push(new Image());
                        break;
                    case 'TextAlign':
                        this.extensions.push(new TextAlign(settings));
                        break;
                    case 'TextColor':
                        this.extensions.push(new TextColor());
                        break;
                    case 'ListItem':
                        this.extensions.push(new ListItem());
                        break;
                    case 'BulletList':
                        this.extensions.push(new BulletList());
                        break;
                    case 'HardBreak':
                        this.extensions.push(new HardBreak());
                        break;
                    case 'HorizontalRule':
                        this.extensions.push(new HorizontalRule());
                        break;
                    case 'CodeView':
                        this.extensions.push(new CodeView(settings));
                        break;
                    case 'History':
                        this.extensions.push(new History());
                        break;
                    case 'Blockquote':
                        this.extensions.push(new Blockquote());
                        break;
                    case 'OrderedList':
                        this.extensions.push(new OrderedList());
                        break;
                    case 'TodoItem':
                        this.extensions.push(new TodoItem());
                        break;
                    case 'TodoList':
                        this.extensions.push(new TodoList());
                        break;
                    case 'Indent':
                        this.extensions.push(new Indent());
                        break;
                    case 'Fullscreen':
                        this.extensions.push(new Fullscreen());
                        break;
                }
            });
            this.loading = false;
        },
    },
    mounted() {
        this.checkExtensions();
        this.$nextTick(() => {
            this.fieldLoaded(); // signal to the form we are loaded
        });

    },
    data() {
        return {
            loading: true,
            extensions: [
                new Doc(),
                new Text(),
                new Paragraph(),
            ]
        }
    },
    computed: {
        defaults() {
            return {
                label: this.innerLabel,
                directions: this.directions,
                persistentHint: true
            };
        },
        rules() {
            return (this.enableValidation) ? {
                ...this.validation_settings,
                ...{
                    required:
                        !!this.validation_settings.required &&
                        !!this.innerShouldShow
                }
            } : {};
        },
        counterValue() {
            if (!this.validation_settings) return undefined;
            else if (this.validation_settings.maxlength)
                return this.validation_settings.maxlength;
            else if (this.validation_settings.minlength) return true;
            return undefined;
        },
        content: {
            get() {
                return this.innerValue;
            },
            set(html) {
                this.innerValue = html.replace(/<p><\/p>/g, '<p><br></p>') // hack to preserve breaks when they want to "add space"
            },
        },
    }
};
</script>

<style lang="scss">
.type-wysiwyg .el-tiptap-editor--empty{
    min-height: 200px;
}
</style>